import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EmailUploadFile } from "../Stores/EmailSubmitStore";
import { Dropdown } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { ItemType } from "antd/lib/menu/interface";

interface EmailAttachmentsTableItemActionsProps extends WithTranslation {
  file: API_FileDataEntity | EmailUploadFile;
  handleAction: (key: string, data: EmailAttachmentsTableItemActionsProps["file"]) => void;
}

export const EmailAttachmentsTableItemActions = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<EmailAttachmentsTableItemActionsProps> {
    handleMenuClick = ({ key, domEvent }) => {
      domEvent.preventDefault();
      domEvent.stopPropagation();
      this.props.handleAction(key, this.props.file);
    };

    get menuItems(): ItemType[] {
      const { t, file } = this.props;
      const items: ItemType[] = [
        {
          key: "remove",
          label: (
            <>
              <FontAwesomeIcon icon={["far", "trash-alt"]} fixedWidth={true} className="mr-5" />
              {t("Remove")}
            </>
          ),
        },
      ];
      if (file.fileActions) {
        if (file.fileActions.download) {
          items.push({
            key: "download",
            label: (
              <>
                <FontAwesomeIcon icon={["far", "download"]} fixedWidth={true} className="mr-5" />
                {t("Download")}
              </>
            ),
          });
        }
        if (file.viewers) {
          if (file.viewers.webViewer) {
            items.push({
              key: "apryse_viewer",
              label: (
                <>
                  <FontAwesomeIcon icon={["far", "eye"]} fixedWidth={true} className="mr-5" />
                  {t("View with WebViewer")}
                </>
              ),
            });
          } else if (file.viewers.easyViewer) {
            items.push({
              key: "easy_view",
              label: (
                <>
                  <FontAwesomeIcon icon={["far", "eye"]} fixedWidth={true} className="mr-5" />
                  {t("View with Easy Viewer")}
                </>
              ),
            });
          } else if (file.viewers.office365) {
            items.push({
              key: "wopi_view",
              label: (
                <>
                  <FontAwesomeIcon icon={["far", "eye"]} fixedWidth={true} className="mr-5" />
                  {t("View with Office Online")}
                </>
              ),
            });
          } else if (file.viewers.onlineViewer) {
            items.push({
              key: "online_view",
              label: (
                <>
                  <FontAwesomeIcon icon={["far", "eye"]} fixedWidth={true} className="mr-5" />
                  {t("View with Online Viewer")}
                </>
              ),
            });
          }
        }
      }
      return items;
    }
    render() {
      return (
        <Dropdown
          menu={{ items: this.menuItems, onClick: this.handleMenuClick, className: "documents-actions" }}
          trigger={["click"]}
        >
          <div className="docs-dropdown-trigger" onClick={(e) => e.stopPropagation()}>
            <FontAwesomeIcon className="email-action-icon" icon={["far", "ellipsis-v"]} fixedWidth={true} />
          </div>
        </Dropdown>
      );
    }
  }
);
